export default "__VITE_ASSET__CykyRKVS__"